import { BowlCollection, isRole, isTenant, roles } from '@websolutespa/payload-plugin-bowl';
import { options } from '../options';

export const LlmFineTuning: BowlCollection = {
  type: 'withCollection',
  slug: options.slug.llmFineTuning,
  admin: {
    group: options.group.llm,
    defaultColumns: ['llmApp', 'question', 'createdAt'],
  },
  access: {
    create: (args) => isRole(roles.Admin, options.roles.LlmEditor)(args),
    read: (args) => isRole(roles.Admin)(args) || isTenant(options.slug.llmFineTuning)(args),
    update: (args) => isRole(roles.Admin)(args) || isTenant(options.slug.llmFineTuning)(args),
    delete: (args) => isRole(roles.Admin)(args) || isTenant(options.slug.llmFineTuning)(args),
  },
  fields: [
    {
      name: 'llmApp',
      type: 'relationship',
      relationTo: options.slug.llmApp,
    },
    {
      name: 'question',
      type: 'withText',
    },
    {
      name: 'answer',
      type: 'withText',
    },
  ],
};

